import React from 'react'
import app from 'xadmin'
import { DepartmentMultipleSelectField, DepartmentSelectField } from './DepartmentSelect'
import { ModelSelectField, ModelSelectMultip } from './ModelSelect'
import NodeTreeSelect from './NodeTreeSelect'
import NodeListSelect from './NodeListSelect'
import { ParentNodeSelectField, ParentNodeFilter } from './ParentNodeSelect'
import TagWrap from './TagWrap'
import TagSelect from './TagSelect'
import EditTable from './EditTable'
import PointTable from './PointTable'
import ModelPointTable from './ModelPointTable'
import CaptchaCodeInput from './CaptchaCodeInput'
import Icon from './Icon'
import Uploading from '../apps/setting/Uploading'
import DataTagPopover from './DataTagPopover'
import NodeTreeSelectMultiple from './NodeTreeSelectMultiple'
import SelectMultiple from './SelectMultiple'
import ModelLogicEditor, { ModelLogicField } from './ModelLogicEditor'
import FilterEnumRewrite from './FilterEnumRewrite'
import FilterNumberRewrite from './FilterNumberRewrite'
import NoData from './NoData'
import FilterRangeTime from './FilterRangeTime'
import { UploadFileInput } from './UploadFile'
import NodeModalSelect, { NodeModalSelectExt } from './NodeModalSelect'
import FiltersHistory from './FiltersHistory'
import PermissionField from './../apps/auth/components/PermissionField'
import QueryEditor from './QueryEditor'
import Password from './Password'
import ResizableModal from './ResizableModal'
import { NodeTree, SelectDepartment } from './../dashboard/NodeTreeSelect'
import TableListSelect from './TableListSelect'
import MainMenu from './MainMenu'
import ParamTypeSchema from './ParamTypeSchema'

export default {
  components: {
    Uploading, Icon, PermissionField, ResizableModal, MainMenu,
    PointTable, ModelPointTable, TagWrap, TagSelect, DataTagPopover,
    NodeTreeSelect, NodeTreeSelectMultiple, NodeListSelect,
    DepartmentSelectField, ModelSelectField, ModelSelectMultip,
    ParentNodeSelectField, ParentNodeFilter, NodeModalSelectExt,
    ModelLogicEditor, EditTable, NoData, NodeModalSelect,
    DepartmentMultipleSelectField, PermissionField, FiltersHistory, QueryEditor, NodeTree, SelectDepartment,
    ParamTypeSchema
  },
  schema_converter: [(f, schema, options) => {
    if (schema.type === 'string' && schema.format == 'date-time') {
      f.type = 'filter_datetime'
    }
    if (schema.type === 'string' && schema.fieldType == 'password') {
      f.type = 'password'
    }
    if (schema.type === 'array' && schema.fieldType == 'department') {
      f.type = 'departmentselect_multip'
    }
    else if (schema.type === 'object' && schema.fieldType == 'department') {
      f.type = 'departmentselect'
    }
    else if (schema.type === 'object' && schema.fieldType == 'model') {
      f.type = 'modelselect'
    }
    else if (schema.type === 'array' && schema.fieldType == 'modelselect_multip') {
      f.type = 'modelselect_multip'
    }
    else if (schema.type === 'object' && schema.fieldType == 'node') {
      f.type = 'nodeselect'
    }
    else if (schema.type === 'object' && schema.fieldType == 'table') {
      f.type = 'tableselect'
    }
    else if (schema.type === 'array' && schema.fieldType == 'parentnode') {
      f.type = 'parent_nodeselect'
    }
    else if (schema.type === 'array' && schema.fieldType == 'select_multiple') {
      f.type = 'select_multiple'
    }
    else if (schema.type === 'array' && schema.fieldType == 'nodeselect_multip') {
      f.type = 'nodeselect_multip'
    }
    else if (schema.type === 'array' && schema.fieldType == 'edittable') {
      f.itemsRender = EditTable
    }
    else if (schema.fieldType == 'tags-select') {
      f.type = 'tagsselect'
    }
    else if (schema.fieldType == 'model-logic') {
      f.type = 'model_logic'
    }
    else if (schema.fieldType == 'upload_file_input') {
      f.type = 'upload_file_input'
    }

    return f
  }],
  form_fields: {
    password: {
      component: Password

    },
    // 部门多选
    departmentselect_multip: {
      component: DepartmentMultipleSelectField
    },
    select_multiple: {
      component: SelectMultiple
    },
    // 部门单选
    departmentselect: {
      component: DepartmentSelectField
    },
    // 模型选择
    modelselect: {
      component: ModelSelectField
    },
    modelselect_multip: {
      component: ModelSelectMultip
    },
    // 资产选择
    nodeselect: {
      component: NodeTreeSelect
    },
    // 
    parent_nodeselect: {
      component: ParentNodeSelectField
    },
    nodeselect_multip: {
      component: NodeTreeSelectMultiple
    },
    // 数据点选择
    tagsselect: {
      component: TagSelect
    },
    // 基于模型的逻辑编辑器
    model_logic: {
      component: ModelLogicField
    },
    captcha: {
      component: CaptchaCodeInput
    },
    filter_enum_rewrite: {
      component: FilterEnumRewrite
    },
    filter_number_rewrite: {
      component: FilterNumberRewrite
    },
    filter_datetime: {
      component: FilterRangeTime
    },
    //上传文件并返回参数作为Value
    upload_file_input: {
      component: UploadFileInput
    },
    filter_parent_node: {
      component: ParentNodeFilter
    },
    tableselect: {
      component: TableListSelect
    }
  },
  filter_converter: [(f, schema, options) => {
    // 修改所有number类型filter组件
    if (f.type == 'filter_number' && schema.type == 'number') {
      f.type = 'filter_number_rewrite'
    }
    // 修改所有enum类型filter组件
    if (f.type == 'filter_enum' && schema.type == 'string') {
      f.type = 'filter_enum_rewrite'
    }

    if (schema.type === 'array' && schema.fieldType == 'department') {
      f.type = 'departmentselect'
    }
    else if (schema.type === 'object' && schema.fieldType == 'department') {
      f.type = 'departmentselect'
    }
    else if (schema.type === 'array' && schema.fieldType == 'modelselect_multip') {
      f.type = 'modelselect_multip'
    }
    else if (schema.type === 'array' && schema.fieldType == 'node') {
      f.type = 'nodeselect'
    }
    else if (schema.type === 'object' && schema.fieldType == 'model') {
      f.type = 'modelselect'
    }
    else if (schema.type === 'object' && schema.fieldType == 'node') {
      f.type = 'nodeselect'
    }
    else if (schema.type === 'object' && schema.fieldType == 'table') {
      f.type = 'tableselect'
    }
    else if (schema.type === 'array' && schema.fieldType == 'parent_node') {
      f.type = 'filter_parent_node'
    }
    else if (schema.type === 'array' && schema.fieldType == 'nodeselect_multip') {
      f.type = 'nodeselect_multip'
    }
    else if (schema.type === 'string' && schema.format == 'date-time') {
      f.type = 'filter_datetime'
    }
    return f
  }]
}
